/**
 * Web TableContext Context
 *
 */

import React from 'react'

export const TableContext = React.createContext(null)

export const TableAccordionContext = React.createContext(null)
